import React, { useEffect, useState } from 'react';
const UNITS_KEY = 'bebe365_units_remaining';
const TOTAL_UNITS = 500;
const INITIAL_REMAINING = 14;
export function TopBanner() {
  const [unitsRemaining, setUnitsRemaining] = useState<number>(INITIAL_REMAINING);
  useEffect(() => {
    const stored = sessionStorage.getItem(UNITS_KEY);
    if (stored) {
      setUnitsRemaining(parseInt(stored));
    } else {
      sessionStorage.setItem(UNITS_KEY, INITIAL_REMAINING.toString());
    }
    // Slowly decrease units over time for urgency
    const interval = setInterval(() => {
      setUnitsRemaining(prev => {
        const newVal = Math.max(prev - 1, 3);
        sessionStorage.setItem(UNITS_KEY, newVal.toString());
        return newVal;
      });
    }, 45000); // decrease by 1 every 45 seconds
    return () => clearInterval(interval);
  }, []);
  return <div className="sticky top-0 z-50 bg-gradient-to-r from-[#8B4A52] via-[#B76E79] to-[#8B4A52] text-white text-center py-2.5 px-4 font-sans text-sm shadow-lg" data-id="element-266">
      <div data-id="element-267">
        🔥{' '}
        <strong className="text-base tracking-wide" data-id="element-268">
          Precio de Lanzamiento: Edición 2026
        </strong>{' '}
        — Cupos Limitados a este precio para los primeros 500 compradores{' '}
        <span className="inline-block bg-white/20 rounded-md px-2.5 py-1 mx-2 text-lg font-bold tracking-widest font-mono" data-id="element-269">
          🎟️ {unitsRemaining}/{TOTAL_UNITS}
        </span>
        Unidades Restantes
      </div>
    </div>;
}